import { ApplicationConfig } from '@angular/core';

import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';

import { HelperService } from './services/helper.service';
import { LoadingInterceptor } from './shared/loader/loading.interceptor';
import { routes } from './app.routes';
import { provideRouter } from '@angular/router';
import { provideLottieOptions } from 'ngx-lottie';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import player from 'lottie-web';
import { provideNgxStripe } from 'ngx-stripe';
import { environment } from '@assets/environment/environment';
import { PaymentService } from './services/payment.service';
import { LoaderService } from './shared/loader/loader.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideLottieOptions({
      player: () => player,
    }),
    provideAnimationsAsync(),
    provideNgxStripe(environment.stripePublishKey),
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptor,
      multi: true,
    },
    HelperService,
    PaymentService,
    LoaderService,
  ],
};
